import React from 'react';
import { WALL_DIRECTION } from '../../utilities/constants/Constants';
import './WallVisualize.scss';
import { string } from '../../localization';

const wallVisualize = props => {
  const {
    setSelectedDirection,
    selectedDirection,
    isActive,
    wallVisualizeIds
  } = props;

  const leftWallId =
    wallVisualizeIds && wallVisualizeIds.length > 0
      ? wallVisualizeIds[0]
      : null;
  const centerWallId =
    wallVisualizeIds && wallVisualizeIds.length > 1
      ? wallVisualizeIds[1]
      : null;
  const rightWallId =
    wallVisualizeIds && wallVisualizeIds.length > 2
      ? wallVisualizeIds[2]
      : null;

  const wallStyle = wallSide => {
    if (wallSide == 'left') {
      if (selectedDirection == WALL_DIRECTION.LEFT) {
        return 'left-wall selected';
      }
      if (leftWallId) {
        return 'left-wall presence';
      }
      return 'left-wall';
    }
    if (wallSide == 'right') {
      if (selectedDirection == WALL_DIRECTION.RIGHT) {
        return 'right-wall selected';
      }
      if (rightWallId) {
        return 'right-wall presence';
      }
      return 'right-wall';
    }
    if (wallSide == 'center') {
      if (selectedDirection == WALL_DIRECTION.CENTER) {
        return 'center-wall selected';
      }
      return 'center-wall';
    }
    return '';
  };

  return (
    <div id='wall-visualize'>
      {!isActive ? (
        <text
          className={
            selectedDirection == WALL_DIRECTION.LEFT
              ? 'left-text selected'
              : 'left-text'
          }
        >
          {string.LEFT_KEY}
        </text>
      ) : null}
      <div
        id={leftWallId}
        role='button'
        aria-label='test'
        className={wallStyle('left')}
        tabIndex='0'
        onKeyPress={() => {}}
        onClick={() => setSelectedDirection(WALL_DIRECTION.LEFT)}
      />
      <div
        id={centerWallId}
        role='button'
        aria-label='test'
        className={wallStyle('center')}
        tabIndex='0'
        onKeyPress={() => {}}
        onClick={() => {
          if (isActive) {
            setSelectedDirection(WALL_DIRECTION.CENTER);
          }
        }}
      />
      <div
        id={rightWallId}
        role='button'
        aria-label='test'
        className={wallStyle('right')}
        tabIndex='0'
        onKeyPress={() => {}}
        onClick={() => setSelectedDirection(WALL_DIRECTION.RIGHT)}
      />
      {!isActive ? (
        <text
          className={
            selectedDirection == WALL_DIRECTION.RIGHT
              ? 'right-text selected'
              : 'right-text'
          }
        >
          {string.RIGHT_KEY}
        </text>
      ) : null}
    </div>
  );
};

export default wallVisualize;
